import React from 'react';
import { Route, Switch } from 'react-router-dom';
import MainWrapper from './MainWrapper';
import Layout from '../Layout/index';

import LogIn from '../LogIn/index';
import Dashboard from '../Dashboard/index';
import Users from '../Users/index';
import Suppliers from '../Suppliers/index';
import Products from '../Products/index';
import Locations from '../Locations/index';
import Inventory from '../Inventory/index';
import Icons from '../Icons/index';
import Transactions from '../Transactions/index';
import Stocks from '../Stocks/index';
import Customers from '../Customers/index';
import Report from '../Report/index';
import Return from '../Return/index';
import StockTracker from '../StockTracker/index';
import Profile from '../Profile/Profile';
// import ProfileSettings from '../ProfileSettings/ProfileSettings';

const wrappedRoutes = () => (
  <div>
    <Layout />
    <div className="container__wrap">
      <Route path="/dashboard" component={Dashboard} />
      <Route path="/profile" component={Profile} />
      <Route path="/locations" component={Locations} />
      <Route path="/users" component={Users} />
      <Route path="/products" component={Products} />
      <Route path="/suppliers" component={Suppliers} />
      <Route path="/customers" component={Customers} />
      <Route path="/inventory/:inventorytype?/:page?/:itemID?" component={Inventory} />
      <Route path="/transactions/:pagetype?" component={Transactions} />
      <Route path="/stocks/:page?/:itemID?" component={Stocks} />
      <Route path="/return" component={Return} />
      <Route path="/report/:pageType?/:pageid?" component={Report} />
      <Route path="/icons" component={Icons} />
      <Route path="/stockstracker/:locationid?/:pageview?/:type?" component={StockTracker} />
    </div>
  </div>
);

const Router = () => (
  <MainWrapper>
    <main>
      <Switch>
        <Route exact path="/" component={LogIn} />
        <Route path="/login" component={LogIn} />
        <Route path="/" component={wrappedRoutes} />
      </Switch>
    </main>
  </MainWrapper>
);

export default Router;
